import { Box, Typography } from "@mui/material"
import { TimeRemainingProps } from "./types"
import { icons } from "../../../../../../utils/icons"
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Constants } from "../../../../../../utils/constants";
import { useStyles } from "./styles";
import { useTranslation } from "react-i18next";
import { CustomPaper } from "../../../../../../components/CustomPaper";



const TimerRemainingComponent = ({ requestDate, limitDate, title, stoper }: TimeRemainingProps) => {

    const styles = useStyles();
    const [secondsLeft, setSecondsLeft] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        if (!requestDate || !limitDate) return;

        if (stoper) {
            setSecondsLeft(0);
            return;
        }

        const start = dayjs(requestDate, Constants.dayjsFormat);
        const end = dayjs(limitDate, Constants.dayjsFormat);

        const calculateRemaining = () => {

            const now = dayjs();

            if (now.isBefore(start)) {
                const total = end.diff(start, "seconds");
                return Math.max(total, 0);
            }

            const diff = end.diff(now, "seconds");
            return Math.max(diff, 0);
        };

        setSecondsLeft(calculateRemaining());

        let intervalId: NodeJS.Timeout | null = null;

        const now = dayjs();

        if (!now.isBefore(start)) {
            intervalId = setInterval(() => {
                setSecondsLeft(calculateRemaining());
            }, 1000);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [requestDate, limitDate]);

    // Conversión
    const isExpired = secondsLeft === 0;
    const days = Math.floor(secondsLeft / 86400).toString().padStart(2, "0");
    const hours = Math.floor((secondsLeft % 86400) / 3600).toString().padStart(2, "0");
    const minutes = Math.floor((secondsLeft % 3600) / 60).toString().padStart(2, "0");
    const seconds = (secondsLeft % 60).toString().padStart(2, "0");

    return (
        <Box sx={styles.container}>
            {title && <Typography>{title}</Typography>}

            <CustomPaper sx={styles.paper}>
                <Box sx={styles.item}>
                    <Typography>{days}</Typography>
                    <Typography color='primary.100'>{t('actionPlan.tags.days')}</Typography>
                </Box>

                <Typography>:</Typography>

                <Box sx={styles.item}>
                    <Typography>{hours}</Typography>
                    <Typography color='primary.100'>{t('actionPlan.tags.hours')}</Typography>
                </Box>

                <Typography>:</Typography>

                <Box sx={styles.item}>
                    <Typography>{minutes}</Typography>
                    <Typography color='primary.100'>{t('actionPlan.tags.minutes')}</Typography>
                </Box>

                <Typography>:</Typography>

                <Box sx={styles.item}>
                    <Typography>{seconds}</Typography>
                    <Typography color='primary.100'>{t('actionPlan.tags.seconds')}</Typography>
                </Box>
            </CustomPaper>
        </Box>
    )
}

export default TimerRemainingComponent
